import { Box } from "@mui/material";
import FlightDelayList from 'components/FlightDelayList';


export function DelaysCard({ data }) {
  
  return (
    <Box 
      id="delays"
      component="section"
      height={450}
      pr={0.5}
      sx={{
        borderRadius: 1,
        border: "1px solid",
        borderColor: "neutral.deep",
        backgroundColor: "background.default",
        overflowY: "auto",
      }}
    > 
      <FlightDelayList flights={data}/>        
    </Box>
  );
}